import * as React from 'react';
import { Link } from '@cian/link-component';
import { IPopupLinkData } from '../../../../shared/types/moderation';

export interface ICheckAnounceRelevancePopupContentProps {
  link: IPopupLinkData | null;
}

export class CheckAnounceRelevancePopupContent extends React.Component<ICheckAnounceRelevancePopupContentProps, {}> {
  public render() {
    const { link } = this.props;

    return (
      <div>
        <span>Подтвердите, пожалуйста, актуальность вашего объявления</span>
        <br />
        {link && (
          <Link href={link.announcementUrl} target="_blank">
            {link.address}
          </Link>
        )}
      </div>
    );
  }
}
